<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
        <template v-slot:activator="{ on: dialog }">
            <v-list-item v-if="activatorType === 'listItem'" v-on="{ ...dialog }" @click.stop.prevent>
                <v-list-item-icon>
                    <v-icon color="error">mdi-trash-can-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title class="error--text mr-5">{{ buttonName || 'Delete' }}</v-list-item-title>
            </v-list-item>
            <v-tooltip v-else bottom>
                <template v-slot:activator="{ on: tooltip }">
                    <v-btn color="error" small icon>
                        <v-icon small v-on="{ ...tooltip, ...dialog }">mdi-trash-can-outline</v-icon>
                    </v-btn>
                </template>
                Delete
            </v-tooltip>
        </template>

        <v-card>
            <v-card-title class="flex-nowrap align-start">
                <div class="secondary--text">
                    {{ dialogTitle }}
                </div>

                <v-spacer></v-spacer>
                <v-btn :disabled="deletingToken" @click="dialog = false" icon><v-icon>clear</v-icon></v-btn>
            </v-card-title>

            <v-card-text>
                <div class="font-weight-bold mb-5">Are you sure you want to delete the following token?</div>
                <div class="subtitle-2">{{ token }}</div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn :loading="deletingToken" color="error" text @click="deleteToken()">delete</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    name: 'DeleteTokenDialog',
    props: {
        token: String,
        dialogTitle: String,
        apiURL: String,
        fetchTokensDispatch: Function,
        activatorType: {
            type: String,
            default: ''
        },
        buttonName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            dialog: false,
            deletingToken: false
        }
    },
    methods: {
        deleteToken: function () {
            this.deletingToken = true
            this.$axios
                .delete(this.apiURL)
                .then(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'Token deleted successfully!',
                        snackBarTimeout: 5000,
                        snackBarIcon: 'check_circle'
                    })
                    this.fetchTokensDispatch()
                })
                .catch(() => {
                    this.$store.dispatch('showSnackBar', {
                        snackBarText: 'Could not delete token.',
                        snackBarTimeout: 5000,
                        snackBarIcon: 'error'
                    })
                })
                .finally(() => {
                    this.deletingToken = false
                    this.dialog = false
                })
        }
    }
}
</script>
